import { render, staticRenderFns } from "./BusinessTrips.vue?vue&type=template&id=2d09493c"
import script from "./BusinessTrips.vue?vue&type=script&lang=js"
export * from "./BusinessTrips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports